<template>
  <div class="sidebar h-100">
    <a-row type="flex">
      <a-col :span="24">
        <SidebarMinimizeButton />
        <SidebarButton v-on:click-event="handleHomeBtnClick()" :tooltipText="user.permissionLevel === 1 ? 'Tableau de bord' : 'Afficher tous les travaux'" buttonIcon="home" buttonText="Home" />
        <SidebarButton v-if="this.$route.path === '/works' && user.permissionLevel === 0" v-on:click-event="handleTogglePrintMyWorksModal()" tooltipText="Imprimer tous mes travaux" buttonIcon="printer" buttonText="Imprimer" />
        <template v-else-if="this.$route.params.numero">
          <SidebarButton v-on:click-event="handleAddDetail()" tooltipText="Ajouter un détail" buttonIcon="plus" buttonText="Ajouter" />
          <SidebarButton v-on:click-event="handleTogglePrintDetailsModal()" tooltipText="Imprimer les détails" buttonIcon="printer" buttonText="Imprimer" />
        </template>
        <template v-if="this.$route.params.numero && user.permissionLevel === 1">
          <SidebarButton v-on:click-event="handleToggleCommentWorkModal()" tooltipText="Ajouter un commentaire global au travail" :buttonTextSmallFontSize="true" buttonIcon="form" buttonText="Commenter" />
          <SidebarButton v-on:click-event="areAllDetailsValidated() ? handleInvalidateAllDetails() : handleValidateAllDetails()" :tooltipText="areAllDetailsValidated() ? 'Supprimer la validation sur tous les détails du travail' : 'Valider tous les détails du travail'" :buttonTextSmallFontSize="true" :buttonIcon="areAllDetailsValidated() ? 'check-circle' : 'check'" :buttonText="areAllDetailsValidated() ? 'Invalider tout' : 'Valider tout'" />
        </template>
        <SidebarButton v-on:click-event="handleDarkThemeBtnClick()" tooltipText="Basculer de thème" buttonIcon="bulb" :buttonIconTheme="darkTheme ? 'outlined' : 'filled'" :buttonText="darkTheme ? 'Thème clair' : 'Thème sombre'" />
        <SidebarButton v-on:click-event="handleDisconnectBtnClick()" tooltipText="Se déconnecter" :buttonTextSmallFontSize="true" buttonIcon="disconnect" buttonText="Déconnecter" />
        <SidebarButton v-on:click-event="handleAboutBtnClick()" tooltipText="Informations relatives à l'application" buttonIcon="info" buttonText="À propos" />
        <!-- Les actions de maintenance de la bdd se font dans phpmyadmin
        <template v-if="user.isAdmin === 'true'">
          <GridSeparator separatorName="Outils admin" />
          <SidebarButton v-on:click-event="handleEditTitlesBtnClick()" tooltipText="Modifier les titres autorisés" buttonIcon="edit" buttonText="Modifier titres" />
          <SidebarButton v-on:click-event="handleExportBtnClick()" tooltipText="Exporter la base de données" buttonIcon="database" buttonText="Exporter" />
          <SidebarButton v-on:click-event="handleClearBtnClick()" tooltipText="Supprimer les données de la base de données" buttonIcon="delete" buttonText="Nettoyer" />
        </template>
        -->
        <PrintModal @clicked="handlePrintMyWorks" :loading="printModalLoading" rangeType="thisWeek" type="my-works" modalTitle="Imprimer mes travaux" />
        <PrintModal @clicked="handlePrintDetails" :loading="printModalLoading" rangeType="allDetails" type="details" modalTitle="Imprimer les détails" />
        <CommentWorkModal  v-if="this.$route.params.numero && user.permissionLevel === 1" @clicked="handleCommentWork" @removed="handleRemoveWork" />
        <AboutModal />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import SidebarButton from '@/components/sidebar/SidebarButton.vue'
import SidebarMinimizeButton from '@/components/sidebar/SidebarMinimizeButton.vue'
import PrintModal from '@/components/modal/PrintModal.vue'
import CommentWorkModal from '@/components/modal/CommentWorkModal.vue'
import AboutModal from '@/components/modal/AboutModal.vue'
import DetailService from '../../services/detail_service'
import WorkService from '../../services/work_service'
import PrintService from '../../services/print_service'
import DateService from '../../services/date_service'

export default {
  name: 'Sidebar',
  components: {
    SidebarButton,
    SidebarMinimizeButton,
    PrintModal,
    CommentWorkModal,
    AboutModal
  },
  data () {
    return {
      printModalLoading: false,
      chrome: this.$browserDetect.isChrome
    }
  },
  methods: {
    moment,
    ...mapActions({
      'togglePrintMyWorksModalVisible': 'modal/togglePrintMyWorksModalVisible',
      'togglePrintDetailsModalVisible': 'modal/togglePrintDetailsModalVisible',
      'toggleCommentWorkModalVisible': 'modal/toggleCommentWorkModalVisible',
      'toggleAboutModalVisible': 'modal/toggleAboutModalVisible',
      'toggleDarkTheme': 'toggleDarkTheme',
      'setDetailsData': 'detail/setDetailsData',
      'setOngoingAlteredRow': 'detail/setOngoingAlteredRow',
      'diconnectUser': 'auth/diconnectUser'
    }),
    handleHomeBtnClick () {
      console.log('home')
      this.$router.push('/works')
    },
    handleTogglePrintMyWorksModal () {
      console.log('handleTogglePrintMyWorksModal')
      this.togglePrintMyWorksModalVisible()
    },
    async handlePrintMyWorks (values) {
      console.log('handlePrintMyWorks')
      this.printModalLoading = true
      const fromData = values.dateRange[0].format('YYYY-MM-DD')
      const toData = values.dateRange[1].format('YYYY-MM-DD')
      const pdf = await PrintService.getWorksDetailsPdf(this.user.login, fromData, toData, values.sort, values.includeComments)
      if (pdf) {
        pdf.output('dataurlnewwindow')
      }
      this.printModalLoading = false
    },
    handleTogglePrintDetailsModal () {
      console.log('handleTogglePrintDetailsModal')
      this.togglePrintDetailsModalVisible()
    },
    async handlePrintDetails (values) {
      console.log('handlePrintDetails')
      this.printModalLoading = true
      const fromDate = values.dateRange[0].format('YYYY-MM-DD')
      const toDate = values.dateRange[1].format('YYYY-MM-DD')
      const pdf = await PrintService.getDetailsPdf(this.selectedWork.numero, fromDate, toDate, values.sort, values.includeComments)
      if (pdf) {
        pdf.output('dataurlnewwindow')
      }
      this.printModalLoading = false
    },
    async handleAddDetail () {
      console.log('add detail')
      // Impossible d'ajouter un détail si une autre ligne est en cours de modification
      if (this.ongoingAlteredRow) {
        this.$message.warning('Un détail est déjà en cours de modification')
        return
      }
      // Récupération du numero du travail
      const numero = this.$route.params.numero
      const params = {
        num_tblTravauxIndex: numero,
        detail: 'Nouveau détail',
        dateDetail: moment().format('YYYY-MM-DD'),
        nbPeriodes: 1
      }
      // Call api création d'un détail avec des données par défaut.
      const response = await DetailService.createDetail(params)
      if (response) {
        const newDetail = response.data.data
        const newDetailNumero = newDetail.numero
        // Si le travail contient des détails
        let newData = []
        if (Array.isArray(this.detailsData) && this.detailsData.length) {
          newData = [...this.detailsData]
        }
        const newRow = {
          ...params,
          detail: '',
          numero: newDetailNumero,
          dateDetail: moment().format('DD.MM.YYYY'),
          loginCreateur: newDetail.loginCreateur,
          classeCreateur: newDetail.classeCreateur,
          loginValidateur: null,
          dateValidation: null,
          heureValidation: null,
          loginCorrecteur: null,
          dateRemediation: null,
          heureRemediation: null,
          remarque: null
        }
        newData.push(newRow)
        this.setDetailsData(newData)
        // nonReactiveCopy est une copie non réactive de newRow
        const nonReactiveCopy = Object.assign({}, newRow)
        nonReactiveCopy.editable = true
        this.setOngoingAlteredRow(nonReactiveCopy)
        this.$message.success('Détail créé')
      }
    },
    handleToggleCommentWorkModal () {
      this.toggleCommentWorkModalVisible()
    },
    async handleCommentWork (values) {
      const params = {
        numero: this.selectedWork.numero,
        remarque: values.remarque
      }
      const response = await WorkService.editWork(params)
      if (response) {
        this.$message.success('Commentaire enregistré')
        Object.assign(this.selectedWork, params)
      }
    },
    async handleRemoveWork () {
      const params = {
        numero: this.selectedWork.numero,
        remarque: null
      }
      const response = await WorkService.editWork(params)
      if (response) {
        this.$message.success('Commentaire supprimé')
        Object.assign(this.selectedWork, params)
      }
    },
    handleValidateAllDetails () {
      // Impossible de valider tout si un détail est en cours de modification
      if (this.ongoingAlteredRow) {
        this.$message.warning('Un détail est déjà en cours de modification')
        return
      }
      if (!this.detailsData || this.detailsData.length <= 0) {
        this.$message.error('Aucun détail à valider')
        return
      }
      this.$confirm({
        title: 'Êtes-vous sûr ?',
        content: 'Cela validera tous les détails du travail.',
        okText: 'Oui',
        cancelText: 'Non',
        onOk: async () => {
          console.log('validate all')
          for (let detail of this.detailsData) {
            // préparation des paramètres
            let params = Object.assign({}, (({ numero, detail }) => ({ numero, detail }))(detail))
            params.loginValidateur = this.user.login
            params.dateValidation = moment().format(DateService.dateDisplayFormat)
            params.heureValidation = moment().format('HH') + 'h' + moment().format('mm')
            const nonReactiveCopy = Object.assign({}, params)
            params = DateService.formatObjectArrayDatesToDisplayFormat([params], 'database')[0]
            // api : modifier le détail
            const response = await DetailService.editDetail(params)
            if (response) {
              Object.assign(detail, nonReactiveCopy)
            }
          }
        }
      })
    },
    async handleInvalidateAllDetails () {
      // Impossible de dévalider tout si un détail est en cours de modification
      if (this.ongoingAlteredRow) {
        this.$message.warning('Un détail est déjà en cours de modification')
        return
      }
      this.$confirm({
        title: 'Êtes-vous sûr ?',
        content: 'Cela va supprimer la validation sur tous les détails du travail',
        okText: 'Oui',
        cancelText: 'Non',
        onOk: async () => {
          console.log('invalidate all')
          if (!this.detailsData || this.detailsData.length <= 0) {
            this.$message.error('Aucun détail à valider')
            return
          }
          for (let detail of this.detailsData) {
            // préparation des paramètres
            let params = Object.assign({}, (({ numero, detail }) => ({ numero, detail }))(detail))
            params.loginValidateur = null
            params.dateValidation = null
            params.heureValidation = null
            const nonReactiveCopy = Object.assign({}, params)
            params = DateService.formatObjectArrayDatesToDisplayFormat([params], 'database')[0]
            // api : modifier le détail
            const response = await DetailService.editDetail(params)
            if (response) {
              Object.assign(detail, nonReactiveCopy)
            }
          }
        }
      })
    },
    handleDarkThemeBtnClick () {
      console.log('dark-theme')
      this.toggleDarkTheme()
    },
    handleDisconnectBtnClick () {
      this.$confirm({
        title: 'Êtes-vous sûr ?',
        content: 'Vous allez être déconnecté',
        okText: 'Oui',
        cancelText: 'Non',
        onOk: () => {
          console.log('disconnect')
          this.diconnectUser()
          this.$router.push('/login')
        }
      })
    },
    handleAboutBtnClick () {
      console.log('about')
      this.toggleAboutModalVisible()
    },
    areAllDetailsValidated () {
      if (this.detailsData && this.detailsData.length >= 1) {
        let validatedDetailCount = 0
        this.detailsData.forEach((detail) => {
          if (detail.loginValidateur) {
            validatedDetailCount++
          }
        })
        if (validatedDetailCount === this.detailsData.length) {
          return true
        }
        return false
      }
      return false
    }
  },
  computed: {
    ...mapState({
      darkTheme: state => state.darkTheme,
      detailsData: state => state.detail.detailsData,
      ongoingAlteredRow: state => state.detail.ongoingAlteredRow,
      user: state => state.auth.user,
      selectedWork: state => state.work.selectedWork
    })
  }
}
</script>

<style scoped lang="scss">
.sidebar{
  width: 100%;
}
</style>
